export enum TestResult {
  pass = 'Pass',
  fail = 'Fail',
  unavailable = 'Unavailable',
}
